import styled from '@emotion/styled';
import Column from '@amzn/meridian/column';
export const HeroContent = styled(Column) `
  position: relative;
  margin: -40px 12px 0 12px !important;
  min-height: clamp(100px, 12vw, 140px);
`;
export const HeroContainer = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  min-height: ${({ isHalloween }) => (isHalloween ? '50vw' : 'MIN(calc(100vh - 200px), 100vw)')};
`;
export const HeroImage = styled.img `
  width: 100%;
  height: auto;
  object-fit: ${({ isCreatorImage }) => (isCreatorImage ? 'contain' : 'cover')};
  max-height: MIN(calc(100vh - 200px), 110vw);
`;
export const HeroVideo = styled.video `
  width: 100%;
  height: auto;
  object-fit: contain;
  max-height: MIN(calc(100vh - 200px), 110vw);
`;
export const HeroGradient = styled.div `
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: ${({ isHalloween }) => (isHalloween ? '70px' : '130px')};
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    ${({ theme }) => theme.rio.semantic.color.background.primary} 100%
  );
`;
export const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 12px;
  gap: 12px;
`;
export const Container = styled.div `
  background: ${({ theme }) => theme.rio.semantic.color.background.secondary};
  border-radius: 8px;
  overflow: hidden;
  padding: 8px;
`;
export const HideScrollbarWrapper = styled.div `
  padding: 4px 12px 0 12px;
  & * {
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  /* Active tab: bold + themed color */
  [role='tab'][aria-selected='true'] {
    color: ${({ theme }) => theme.rio.semantic.color.interaction.primary} !important;
    font-weight: bold;
    letter-spacing: normal;
  }
  /* Inactive tab: normal weight with letter-spacing to approximate bold tab width*/
  [role='tab'][aria-selected='false'] {
    color: ${({ theme }) => theme.rio.semantic.color.font.primary} !important;
    font-weight: normal;
    letter-spacing: 0.3px;
  }
  /* Active tab underline color to match text color */
  [role='tab'][aria-selected='true'] > div {
    background-color: ${({ theme }) => theme.rio.semantic.color.interaction.primary} !important;
  }
  /* Remove blue tap highlight flash */
  [role='tab'] {
    -webkit-tap-highlight-color: transparent;
  }
`;
